export interface BankValidationObject {
	name: string;
	type: number;
	comment: number;
	clearingRegex: RegExp;
	regex: RegExp;
}

export const banks: BankValidationObject[] = [
	{
		name: "Svea Bank",
		type: 1,
		comment: 2,
		clearingRegex: /^966[0-9]$/,
		regex: /^966[0-9]{8}$/,
	},
	{
		name: "Aion Bank",
		type: 1,
		comment: 1,
		clearingRegex: /^958[0-9]$/,
		regex: /^958[0-9]{8}$/,
	},
	{
		name: "Avanza Bank",
		type: 1,
		comment: 2,
		clearingRegex: /^95[5-6][0-9]$/,
		regex: /^95[5-6][0-9]{8}$/,
	},
	{
		name: "BlueStep Finans",
		type: 1,
		comment: 1,
		clearingRegex: /^968[0-9]$/,
		regex: /^968[0-9]{8}$/,
	},
	{
		name: "BNP Paribas SA.",
		type: 1,
		comment: 2,
		clearingRegex: /^947[0-9]$/,
		regex: /^947[0-9]{8}$/,
	},
	{
		name: "Citibank",
		type: 1,
		comment: 2,
		clearingRegex: /^904[0-9]$/,
		regex: /^904[0-9]{8}$/,
	},
	{
		name: "Danske Bank",
		type: 1,
		comment: 1,
		clearingRegex: /^(12|13|24)[0-9]{2}$/,
		regex: /^(12|13|24)[0-9]{9}$/,
	},
	{
		name: "DNB Bank",
		type: 1,
		comment: 2,
		clearingRegex: /^(919|926)[0-9]$/,
		regex: /^(919|926)[0-9]{8}$/,
	},
	{
		name: "Ekobanken",
		type: 1,
		comment: 2,
		clearingRegex: /^970[0-9]$/,
		regex: /^970[0-9]{8}$/,
	},
	{
		name: "Erik Penser",
		type: 1,
		comment: 2,
		clearingRegex: /^959[0-9]$/,
		regex: /^959[0-9]{8}$/,
	},
	{
		name: "Forex Bank",
		type: 1,
		comment: 1,
		clearingRegex: /^94[0-4][0-9]$/,
		regex: /^94[0-4][0-9]{8}$/,
	},
	{
		name: "ICA Banken",
		type: 1,
		comment: 1,
		clearingRegex: /^927[0-9]$/,
		regex: /^927[0-9]{8}$/,
	},
	{
		name: "IKANO Bank",
		type: 1,
		comment: 1,
		clearingRegex: /^917[0-9]$/,
		regex: /^917[0-9]{8}$/,
	},
	{
		name: "JAK Medlemsbank",
		type: 1,
		comment: 2,
		clearingRegex: /^967[0-9]$/,
		regex: /^967[0-9]{8}$/,
	},
	{
		name: "Klarna Bank",
		type: 1,
		comment: 2,
		clearingRegex: /^978[0-9]$/,
		regex: /^978[0-9][0-9]{7}$/,
	},
	{
		name: "Landshypotek",
		type: 1,
		comment: 2,
		clearingRegex: /^939[0-9]$/,
		regex: /^939[0-9]{8}$/,
	},
	{
		name: "Lunar Bank",
		type: 1,
		comment: 2,
		clearingRegex: /^971[0-9]$/,
		regex: /^971[0-9]{8}$/,
	},
	{
		name: "LÃ¥n & Spar Bank Sverige",
		type: 1,
		comment: 1,
		clearingRegex: /^963[0-9]$/,
		regex: /^963[0-9]{8}$/,
	},
	{
		name: "LÃ¤nsfÃ¶rsÃ¤kringar Bank",
		type: 1,
		comment: 1,
		clearingRegex: /^(340|906)[0-9]$/,
		regex: /^(340|906)[0-9]{8}$/,
	},
	{
		name: "LÃ¤nsfÃ¶rsÃ¤kringar Bank",
		type: 1,
		comment: 2,
		clearingRegex: /^902[0-9]$/,
		regex: /^902[0-9]{8}$/,
	},
	{
		name: "Marginalen Bank",
		type: 1,
		comment: 1,
		clearingRegex: /^923[0-9]$/,
		regex: /^923[0-9]{8}$/,
	},
	{
		name: "Multitude Bank",
		type: 1,
		comment: 1,
		clearingRegex: /^907[0-9]$/,
		regex: /^907[0-9]{8}$/,
	},
	{
		name: "MedMera Bank",
		type: 1,
		comment: 2,
		clearingRegex: /^965[0-9]$/,
		regex: /^965[0-9]{8}$/,
	},
	{
		name: "Nordax Bank",
		type: 1,
		comment: 2,
		clearingRegex: /^964[0-9]$/,
		regex: /^964[0-9]{8}$/,
	},
	{
		name: "Nordea",
		type: 1,
		comment: 1,
		clearingRegex: /^(11|14|15|16|17|18|19|20)[0-9]{2}$/,
		regex: /^((11|14|15|16|17|18|19|20)[0-9]{2})[0-9]{7}$/,
	},
	{
		name: "Nordea (personkonto)",
		type: 2,
		comment: 1,
		clearingRegex: /^3(300|782)$/,
		regex: /^(3(300|782))[0-9]{10}$/, // "personkonto"
	},
	{
		name: "Nordea",
		type: 1,
		comment: 1,
		clearingRegex: /^3(?!(300))[0-3][0-9]{2}$/,
		regex: /^(3(?!(300|782))[0-3][0-9]{2})[0-9]{7}$/,
	},
	{
		name: "Nordea",
		type: 1,
		comment: 1,
		clearingRegex: /^(34[1-9][0-9]|3(?!782)[5-9][0-9]{2})$/,
		regex: /^(34[1-9][0-9]|3[5-9][0-9]{2})[0-9]{7}$/,
	},
	{
		name: "Nordea",
		type: 1,
		comment: 2,
		clearingRegex: /^4[0-9]{3}$/,
		regex: /^4[0-9]{10}$/,
	},
	{
		name: "Nordnet Bank",
		type: 1,
		comment: 2,
		clearingRegex: /^910[0-9]$/,
		regex: /^910[0-9]{8}$/,
	},
	{
		name: "Northmill Bank AB",
		type: 1,
		comment: 2,
		clearingRegex: /^975[0-9]$/,
		regex: /^975[0-9]{8}$/,
	},
	{
		name: "Resurs Bank",
		type: 1,
		comment: 1,
		clearingRegex: /^928[0-9]$/,
		regex: /^928[0-9]{8}$/,
	},
	{
		name: "RiksgÃ¤lden",
		type: 1,
		comment: 2,
		clearingRegex: /^988[0-9]$/,
		regex: /^988[0-9]{8}$/,
	},
	{
		name: "RiksgÃ¤lden",
		type: 2,
		comment: 1,
		clearingRegex: /^989[0-9]$/,
		regex: /^989[0-9]{11}$/,
	},
	{
		name: "ABN AMRO / Royal Bank of Scotland",
		type: 1,
		comment: 1,
		clearingRegex: /^909[0-9]$/,
		regex: /^909[0-9]{8}$/,
	},
	{
		name: "Santander Consumer Bank",
		type: 1,
		comment: 1,
		clearingRegex: /^946[0-9]$/,
		regex: /^946[0-9]{8}$/,
	},
	{
		name: "SBAB",
		type: 1,
		comment: 1,
		clearingRegex: /^925[0-9]$/,
		regex: /^925[0-9]{8}$/,
	},
	{
		name: "SEB",
		type: 1,
		comment: 1,
		clearingRegex: /^(5[0-9]{3}|912[0-4]|91[3-4][0-9])$/,
		regex: /^(5[0-9]{3}|912[0-4]|91[3-4][0-9])[0-9]{7}$/,
	},
	{
		name: "Skandiabanken",
		type: 1,
		comment: 2,
		clearingRegex: /^91[5-6][0-9]$/,
		regex: /^91[5-6][0-9]{8}$/,
	},
	{
		name: "Swedbank",
		type: 1,
		comment: 1,
		clearingRegex: /^7[0-9]{3}$/,
		regex: /^7[0-9]{10}$/,
	},
	{
		name: "Ã…landsbanken",
		type: 1,
		comment: 2,
		clearingRegex: /^23[0-9]{2}$/,
		regex: /^(23[0-9]{2})[0-9]{7}$/,
	},
	{
		name: "Danske Bank",
		type: 2,
		comment: 1,
		clearingRegex: /^918[0-9]$/,
		regex: /^918[0-9]{11}$/,
	},
	{
		name: "Handelsbanken",
		type: 2,
		comment: 2,
		clearingRegex: /^6[0-9]{3}$/,
		regex: /^6[0-9]{12}$/,
	},
	{
		name: "Nordea Plusgirot",
		type: 2,
		comment: 3,
		clearingRegex: /^(95[0-4]|996)[0-9]$/,
		regex: /^(95[0-4]|996)[0-9]{8,11}$/, // Clearingnbr 4 digits, accountNbr 7-10 digits
	},
	{
		name: "Sparbanken Syd",
		type: 2,
		comment: 1,
		clearingRegex: /^957[0-9]$/,
		regex: /^957[0-9]{11}$/,
	},
	{
		name: "Sparbanken Nord",
		type: 2,
		comment: 3,
		clearingRegex: /^82644$/,
		regex: /^(82644)[0-9]{9,10}$/,
	},
	{
		name: "AlingsÃ¥s Sparbank",
		type: 2,
		comment: 3,
		clearingRegex: /^83048$/,
		regex: /^(83048)[0-9]{10}$/,
	},
	{
		name: "Sparbanken i EnkÃ¶ping",
		type: 2,
		comment: 3,
		clearingRegex: /^83055$/,
		regex: /^(83055)[0-9]{8,10}$/,
	},
	{
		name: "Swedbank",
		type: 2,
		comment: 3,
		clearingRegex: /^(8(?!(1095|2644|3048|3055|0796|3139|3931))[0-9]{4})$/,
		regex: /^(8(?!(1095|2644|3048|3055|0796|3139|3931))[0-9]{4})[0-9]{7,11}$/, // ClearingNbr 5 digits, accountNbr 7-10 digits
	},
	{
		name: "Swedbank",
		type: 2,
		comment: 1,
		clearingRegex: /^93[0-4][0-9]/,
		regex: /^93[0-4][0-9]{11}$/,
	},
	{
		name: "Sparbanken SkÃ¥ne",
		type: 2,
		comment: 3,
		clearingRegex: /^80796$/,
		regex: /^(80796)[0-9]{10}$/,
	},
	{
		name: "Sparbanken 1826",
		type: 2,
		comment: 3,
		clearingRegex: /^83139$/,
		regex: /^(83139)[0-9]{10}$/,
	},
	{
		name: "LÃ¶nneberga-Tuna-Vena Sparbank",
		type: 2,
		comment: 3,
		clearingRegex: /^83931$/,
		regex: /^(83931)[0-9]{10}$/,
	},
	{
		name: "JP Nordiska",
		type: 1,
		comment: 2,
		clearingRegex: /^(23(?!10))([0-9]{2})$/,
		regex: /^(23(?!10))([0-9]{2})[0-9]{7}$/,
	},
];
